import { useTranslation } from 'react-i18next'
import { ChangeEvent, KeyboardEventHandler, ReactNode, RefObject } from 'react'
import { TextField, useTheme } from '@mui/material'

import useStyles from './styles'
import { ETranslationNs } from 'src/types'

interface ITextInputProps {
  inputUpperLabel?: ReactNode
  inputPlaceholder?: string
  inputName?: string
  multiline?: boolean
  error?: string
  value?: string | null
  handleChange?: (e: ChangeEvent<HTMLInputElement>) => void
  disableBorder?: boolean
  disabled?: boolean
  fullWidth?: boolean
  rows?: number
  inputRef?: RefObject<HTMLInputElement | null>
  onKeyDown?: KeyboardEventHandler<HTMLDivElement>
  endIcon?: ReactNode
  fontSize?: number
}

const TextInput = ({
  inputUpperLabel,
  inputPlaceholder,
  inputName,
  multiline,
  error,
  value = '',
  handleChange,
  disableBorder,
  disabled,
  fullWidth,
  rows,
  inputRef,
  onKeyDown,
  endIcon,
  fontSize,
}: ITextInputProps) => {
  const [t] = useTranslation(ETranslationNs.Form)
  const theme = useTheme()
  const classes = useStyles({ multiline, disableBorder, fullWidth, disabled })

  const placeholder =
    inputPlaceholder && `${t('text-input-placeholder-prepend.v')} ${inputPlaceholder}`
  return (
    <TextField
      variant="standard"
      className={classes.container}
      autoComplete="off"
      InputProps={{
        disableUnderline: true,
        multiline,
        rows: rows ?? 7,
        endAdornment: endIcon,
        style: {
          fontSize: 2,
        },
      }}
      inputProps={{
        className: classes.input,
        style: {
          fontSize: fontSize ?? 'none',
        },
      }}
      InputLabelProps={{
        className: classes.label,
        style: {
          color: theme.palette.custom.grey2,
        },
      }}
      onChange={handleChange}
      focused
      size="small"
      value={value ? value : disabled ? placeholder : ''}
      label={inputUpperLabel}
      id={inputName}
      name={inputName}
      fullWidth
      multiline={multiline}
      placeholder={inputPlaceholder && placeholder}
      type="text"
      error={!!error}
      helperText={error}
      disabled={disabled}
      inputRef={inputRef}
      onKeyDown={onKeyDown}
    />
  )
}

export { TextInput }
